var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeartbreak(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.06 4c3.81.03 5.9 3.75 3.7 8.4-1.84 3.92-5.75 7.43-7.78 7.6h-.16c-1.94 0-5.85-3.42-7.8-7.32l-.13-.28C1.7 7.75 3.8 4.03 7.6 4c.98 0 1.93.28 2.7.82A.98.98 0 119.2 6.44c-.45-.31-1-.48-1.58-.48-2.32.02-3.55 2.2-1.94 5.6a15.24 15.24 0 003.66 4.86 8.1 8.1 0 002.44 1.61H11.84c.27 0 1.39-.64 2.5-1.61a15.24 15.24 0 003.65-4.86c1.6-3.4.38-5.58-1.94-5.6-.58 0-1.13.17-1.58.48a4.56 4.56 0 00-1.5 1.73l-.1.2-.05.13-.06.19-.56 1.54h2.14c.73 0 1.2.77.88 1.4l-.05.1-2.5 3.98a.98.98 0 01-1.72-.95l.06-.1 1.55-2.46h-1.77a.98.98 0 01-.95-1.22l.03-.1 1.04-2.83.02-.1c.17-.56.54-1.28 1.17-2l.18-.2a6.5 6.5 0 011.07-.93 4.73 4.73 0 012.7-.82z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartbreak);
export default __webpack_public_path__ + "static/media/heartbreak.34ba208c.svg";
export { ForwardRef as ReactComponent };